export default {
  methods: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    decapitalize(str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    },
    capitalizeParagraph(str) {
      const str_lower = str.toLowerCase();
      const arr = str_lower.split(' ');

      //loop through each element of the array and capitalize the first letter.
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }
      //Join all the elements of the array back into a string
      //using a blankspace as a separator
      return arr.join(' ');
    },
  },
};
